export const comments_4180328 = {"data":{"data":[],"links":{}}}